if (!customElements.get('sr-discount-countdown')) {
  customElements.define('sr-discount-countdown', class extends HTMLElement {
    connectedCallback() {
      this.startsAt = Number(this.dataset.startsAt) * 1000;
      this.endsAt = Number(this.dataset.endsAt) * 1000;
      this.parts = {
        days: this.querySelector('[data-countdown-days]'),
        hours: this.querySelector('[data-countdown-hours]'),
        minutes: this.querySelector('[data-countdown-minutes]'),
        seconds: this.querySelector('[data-countdown-seconds]'),
      };
      this.dayUnit = this.querySelector('[data-countdown-unit="days"]');
      this.label = this.querySelector('[data-countdown-label]');
      this.bar = this.querySelector('[data-countdown-bar]');
      this.deadlineText = this.querySelector('[data-countdown-deadline]');

      const missingPart = Object.values(this.parts).some((node) => !node);
      if (missingPart || !Number.isFinite(this.startsAt) || !Number.isFinite(this.endsAt)) return;

      const deadline = new Date(this.endsAt);
      const spoken = deadline.toLocaleString(document.documentElement.lang || 'en', {
        dateStyle: 'medium', timeStyle: 'long',
      });
      this.setAttribute('aria-label', `Offer ends ${spoken}`);
      if (this.deadlineText) {
        this.deadlineText.textContent = `Ends ${deadline.toLocaleString(document.documentElement.lang || 'en', {
          weekday: 'short', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit',
        })}`;
      }

      this.onVisibilityChange = () => this.tick();
      document.addEventListener('visibilitychange', this.onVisibilityChange);
      if (this.tick()) this.interval = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
    }

    tick() {
      const now = Date.now();
      const seconds = Math.ceil((this.endsAt - now) / 1000);
      this.hidden = now < this.startsAt || seconds <= 0;
      if (this.hidden) {
        clearInterval(this.interval);
        return false;
      }

      const days = Math.floor(seconds / 86400);
      const pad = (value) => String(value).padStart(2, '0');
      this.parts.days.textContent = String(days);
      this.parts.hours.textContent = pad(Math.floor((seconds % 86400) / 3600));
      this.parts.minutes.textContent = pad(Math.floor((seconds % 3600) / 60));
      this.parts.seconds.textContent = pad(seconds % 60);
      if (this.dayUnit) this.dayUnit.hidden = days === 0;

      // The bar drains across the offer's own window, so a nearly spent
      // offer reads as nearly spent before anyone parses the digits.
      const span = this.endsAt - this.startsAt;
      if (this.bar && span > 0) {
        const remaining = Math.min(1, Math.max(0, (this.endsAt - now) / span));
        this.bar.style.width = `${(remaining * 100).toFixed(3)}%`;
      }

      const urgency = seconds <= 3600 ? 'final' : seconds <= 86400 ? 'soon' : 'calm';
      if (urgency !== this.urgency) {
        this.urgency = urgency;
        this.dataset.urgency = urgency;
        if (this.label) this.label.textContent = urgency === 'final' ? 'Ends in' : 'Offer ends in';
      }
      return true;
    }
  });
}
